import { ACTION_TYPES, useAgreementSearchDispatch, useAgreementSearchState } from './agreement-search-context';
import AgreementAppService from '../../../../application/platform/apm/agreement/agreement-app-service';
import { IAgreementListResponse } from '../../../../model/apm/agreement/response/agreement-list-response';
import { IAgreementAddEditRequest } from '../../../../model/apm/agreement/request/agreement-add-edit-request';
import { IAgreementPagedRequest } from '../../../../model/apm/agreement/request/agreement-paged-request';
import { parseNumberInput } from '../../../../utils/format';
import { useActionRunner } from '../../../../hooks/use-action-runner';
import { useSearchActions } from '../../../../hooks/use-search-actions';

export const useAgreementSearchController = () => {
    const dispatch = useAgreementSearchDispatch();
    const state = useAgreementSearchState();
    const { isSaving, runSaving, runWithLoading, run, showSuccess, confirmDelete } = useActionRunner();
    const { updateParameters, triggerSearch, ...searchHandlers } = useSearchActions<IAgreementPagedRequest>(dispatch, ACTION_TYPES, { term: undefined, year: undefined });

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'input-term') updateParameters({ term: value || undefined });
        if (name === 'input-year') updateParameters({ year: parseNumberInput(value) });
    }

    // A listagem não traz o objetivo, então a edição busca o convênio completo
    function openDrawer(row?: IAgreementListResponse) {
        if (!row) {
            dispatch({ type: ACTION_TYPES.openDrawer });
            return;
        }
        runWithLoading('Não foi possível carregar o convênio', async () => {
            dispatch({ type: ACTION_TYPES.openDrawer, payload: await AgreementAppService.getById(row.id) });
        });
    }

    function closeDrawer() {
        dispatch({ type: ACTION_TYPES.closeDrawer });
    }

    function handleSave(request: IAgreementAddEditRequest) {
        const editing = state.drawer.agreement;
        return runSaving('Não foi possível salvar o convênio', async () => {
            await (editing ? AgreementAppService.edit(editing.id, request) : AgreementAppService.add(request));
            showSuccess(editing ? 'Convênio atualizado com sucesso!' : 'Convênio cadastrado com sucesso!');
            closeDrawer();
            triggerSearch();
        });
    }

    function handleDelete(row: IAgreementListResponse) {
        confirmDelete(`Tem certeza que deseja excluir o convênio com "${row.superiorBody}"?`, () => run('Não foi possível excluir o convênio', async () => {
            await AgreementAppService.remove(row.id);
            showSuccess('Convênio excluído com sucesso!');
            triggerSearch();
        }));
    }

    return {
        isSaving,
        handleOnChange, ...searchHandlers,
        openDrawer, closeDrawer, handleSave, handleDelete,
    };
};
